module.exports = __webpack_public_path__ + "static/img/game1.c0368c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game1.jpg
// module id = ngKV
// module chunks = 1